import type { FaireProductEntity } from "../../entity_types/product";

export const p_f6wrzpfrh8: FaireProductEntity = {
  token: "p_f6wrzpfrh8",
  type: "product",
  name: "Wide-Leg Bhutani Trim Pants – Prepack of 4 Colors – Stripes",
  brandToken: "b_vn9q3djcqf",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/2bfa9ff6f25c8b5ff5c36cdce5a01da67f676d8f1ff9dc5e4904ddc7b4919a40.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2f080e965958b933e0ce2fc189d2682cdf0b85dbe1825bd47ee7ca6d7cab25d8.jpeg",
    "https://cdn.faire.com/fastly/95a3e3c82cba9299ee24203af93a5d3fe67b82388418b7c3b5837fbae2330ef8.jpeg",
    "https://cdn.faire.com/fastly/b38252a3905656fbd91302bdf5bdeb2676f8b0d445d5e6e57c5d1dad80d49296.jpeg",
    "https://cdn.faire.com/fastly/81342735176eb7e0deeef5082a58732c655ff585de2e4e8bcfb20a3ab2102ea0.jpeg",
  ],
  priceDollars: 138.57,
  description:
    'Elevate your vibe, and make a lasting impression with our exotic boho flared trousers. Harmoniously fitted yet flowing, first date, job interview, or basking in a hammock, here you come, in the comfort and taste you deserve. Adorned with elegantly versatile cuffs, crafted of specially imported cotton, look and feel amazing, rocking these boho flared trousers anywhere and way you choose. Enhance your style today, and smile!\n\nBrand: Katmandu Trading Company\nCountry Of Origin: Handmade in Nepal\nAvailability: Limited\nSizing: Free size/Fits most up to 42" waist\nMaterial: Handwoven organic Khaddar cotton\nSpecial Features: Secret pocket, Katmandu Compass embroidered patch, wrinkle-resistant, natural dyes, unisex\nAdditional Information: Machine washable, drawstrings, hanging straps/keyring holders, traditional pockets',
  tags: [],
  msrpDollars: 277.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:36.068Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
